module.exports = __webpack_public_path__ + "img/error.48b9a28.svg";